import moduleAbilities from "@/composables/moduleAbilities";
import abilities from "@/composables/abilities";

export default {
    /*
    |--------------------------------------------------------------------------
    | projects Routes
    |--------------------------------------------------------------------------|
    */

    path: 'karaokes',
    name: 'karaokes',
    children: [
        {
            path: 'list',
            component: () => import('@/Modules/Karaoke/views/karaokes/Index.vue'),
            name: 'karaokes-index',
          //  meta: {  requiresPermission: [abilities.CAN_VIEW_EVENT, abilities.CAN_VIEW_ALL_EVENT], requiresAccess: [moduleAbilities.EVENT_PORTAL]},
        },
        {
            path: ':id/view',
            component: () => import('@/Modules/Karaoke/views/karaokes/View.vue'),
            name: 'karaokes-view',
            //  meta: {  requiresPermission: [abilities.CAN_VIEW_EVENT, abilities.CAN_VIEW_ALL_EVENT], requiresAccess: [moduleAbilities.EVENT_PORTAL]},
        },
    ]
}
